import { getAuth } from "firebase/auth";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { Message } from "~/API";
import { apiClient, MessageTableLoaderResult } from "~/services/apiClient";

export const MessageTablePageLoader = async ({
  request,
}: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const response = await apiClient.loader<MessageTableLoaderResult>(
    "message-table",
    {
      tenantName: user!.displayName ?? undefined,
    },
  );

  if (!response.success || !response.data) {
    return {
      user: {
        userID: user!.uid,
        tenantID: user!.tenantId ?? "",
        tenantName: user!.displayName ?? "",
      },
      messages: [] as Message[],
    };
  }

  return response.data;
};

export type MessageTablePageLoaderType = {
  messages: Message[];
  user: {
    userID: string;
    tenantID: string;
    tenantName: string;
  };
};
